import React, { useState, useRef, useEffect, useContext, useMemo } from "react"; 
import { Container, Row, Col} from "react-bootstrap";
import PDF from "../../pdf/dummy.pdf";
import {  useParams } from 'react-router-dom'
import "./ResearchReport.css";
//import pdficon from "../../Images/Excel.png";
import pdficon from "../../Images/Images/Excel.png"
import htmlicon from "../../Images/htmlicon.png";
import URLstateContext from "../../provider/CommonContext";
import Pagination from '../CommonUI/Pagination/Pagination';

let PageSize = 10;
function ResearchReport(props) {
    const {BaseLiveURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const { catname } = useParams();
    const [categoryname, setcategoryname] = useState(catname.replace(/-/g, ' '));
    const [nodatafound, setnodatafound] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [sectionname, SetSectionname] = useState();
    
    useEffect(() => {
       
         
        postData('../../../api/Login/getsectioncatid', { catname: catname})
            .then((data) => {
                 
                if (data.data != null && data.data.length > 0) {
                    //console.log("data:" + JSON.stringify(data.data));
                    setData(data.data);
                    
                    //SetSectionname(data.data[0]["report"]);
                }
                else { setData([]); setnodatafound(true); }
            });

    }, []);

     

    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        if (data.length > 0) {
            return data.slice(firstPageIndex, lastPageIndex);
        }
    }, [currentPage,data]);
    async function postData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }
    return(
        <>
            <section className="download-sc">
                <Container>
                    <Row>
                        <Col xl={12}>
                            <div className="section-header">
                                <h2>{categoryname}</h2>
                                 
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12}>
                            <div className="note-table table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                           
                                            <th className="text-center">Date</th>
                                            <th className="text-center">Caption</th>
                                            <th className="text-center">Analyst Name</th>
                                            <th className="text-center">Download Excel</th>
                                            {/* <th className="text-center">Download HTML</th> */}
                                        </tr>
                                    </thead>
                                    <tbody  >
                                        {currentTableData &&
                                            currentTableData.map(
                                                ({ caption, analystname,date , uploadpdf,uploadhtml },index) => (
                                                    <tr>
                                                        
                                                        <td className="textcenter">{date}</td>
                                                        <td>{caption}</td>
                                                        <td>{analystname}</td>
                                                        <td className="textcenter">
                                                            <a href={BaseLiveURL + "pdf/" + uploadpdf} download>
                                                                <img className="imgwidth" src={pdficon} />
                                                            </a>
                                                        </td>
                                                        {/* <td className="textcenter">
                                                            <a href={BaseLiveURL + "pdf/" + uploadhtml} download>
                                                                <img className="imgwidth" src={htmlicon} />
                                                            </a>
                                                        </td> */}
                                                    </tr>
                                                )
                                            )}
                                        {nodatafound &&
                                            <tr>
                                            <td colSpan="5" className="textcenter nodata">No Research Reports found for  {categoryname} !!!</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                                <Pagination
                                    className="pagination-bar"
                                    currentPage={currentPage}
                                    totalCount={data.length}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                />
                            </div>
                        </Col>
                    </Row>
                    <p>Note* <a href="https://www.moneysukh.com/disclaimer">   Please refer to disclaimer</a></p>
                </Container>
            </section>
        </>
    );
}
export default ResearchReport;